import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { streamActions, streamSelectors } from '../../../store/modules/stream';

const useStreamsEmptyCheck = (canFetch = true) => {
  const isEmpty = useSelector(streamSelectors.selectIsStreamsEmpty);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isEmpty === false) return;

    canFetch && dispatch(streamActions.checkStreamsEmpty());
  }, [canFetch]);

  return { hasStreams: isEmpty === null || !isEmpty };
};

export default useStreamsEmptyCheck;
